import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'transaction_type_label', label: 'Transaction Type' },
  { key: 'mapped_account', label: 'Mapped Account' },
  { key: 'direction', label: 'Direction' },
  { key: 'is_active', label: 'Active' },
];

export function AccountMappingReport() {
  return (
    <ReportView
      title="GL Account Mapping"
      description="Which chart-of-accounts code each automated GL transaction type posts against, and in which direction."
      endpoint="/reports/gl/account-mapping"
      columns={COLUMNS}
    />
  );
}
